<div class="container">
  <div class="landing">
    <!-- Hero -->
    <section class="hero" id="hero">
      <div class="hero__image">
        <img src="../../../../assets/integrations/dimria.png" alt="DIM.RIA CRM">
      </div>
      <div class="hero__content">
        <h1 class="hero__title">{{ 'dom_page.hero_title' | translate }}</h1>
        <p class="hero__subtitle">{{ 'dom_page.hero_subtitle' | translate }}</p>
        <a [href]="environment.login_url">
          <app-button [title]="'dom_page.hero_button' | translate"></app-button>
        </a>
      </div>
      <div class="hero__scroll" (click)="scrollTo('features')">
        <app-icon>expand_more</app-icon>
      </div>
    </section>

    <!-- Features -->
    <section class="section-container" id="features">
      <h2 class="section-title">{{ 'dom_page.features_title' | translate }}</h2>
      <ul class="features-list">
        <li>{{ 'dom_page.feature_1' | translate }}</li>
        <li>{{ 'dom_page.feature_2' | translate }}</li>
        <li>{{ 'dom_page.feature_3' | translate }}</li>
        <li>{{ 'dom_page.feature_4' | translate }}</li>
        <li>{{ 'dom_page.feature_5' | translate }}</li>
        <li>{{ 'dom_page.feature_6' | translate }}</li>
      </ul>
    </section>

    <!-- AI -->
    <section class="section-container" id="advantages">
      <h2 class="section-title">{{ 'dom_page.ai_title' | translate }}</h2>
      <ul class="features-list">
        <li>{{ 'dom_page.ai_feature_1' | translate }}</li>
        <li>{{ 'dom_page.ai_feature_2' | translate }}</li>
        <li>{{ 'dom_page.ai_feature_3' | translate }}</li>
        <li>{{ 'dom_page.ai_feature_4' | translate }}</li>
      </ul>
    </section>

    <app-interface-for-all></app-interface-for-all>

    <!-- For Whom -->
    <section class="section-container" id="for-whom">
      <h2 class="section-title">{{ 'dom_page.audience_title' | translate }}</h2>
      <ul class="audience-list">
        <li>{{ 'dom_page.audience_1' | translate }}</li>
        <li>{{ 'dom_page.audience_2' | translate }}</li>
        <li>{{ 'dom_page.audience_3' | translate }}</li>
        <li>{{ 'dom_page.audience_4' | translate }}</li>
      </ul>
    </section>

    <app-advantages></app-advantages>

    <app-reviews></app-reviews>

    <!-- FAQ -->
    <section class="section-container" id="faq">
      <h2 class="section-title">{{ 'dom_page.faq_title' | translate }}</h2>
      <div class="faq-list">
        <div class="faq-item">
          <h3 class="faq-question">{{ 'dom_page.faq_1_question' | translate }}</h3>
          <p class="faq-answer">{{ 'dom_page.faq_1_answer' | translate }}</p>
        </div>
        <div class="faq-item">
          <h3 class="faq-question">{{ 'dom_page.faq_2_question' | translate }}</h3>
          <p class="faq-answer">{{ 'dom_page.faq_2_answer' | translate }}</p>
        </div>
        <div class="faq-item">
          <h3 class="faq-question">{{ 'dom_page.faq_3_question' | translate }}</h3>
          <p class="faq-answer">{{ 'dom_page.faq_3_answer' | translate }}</p>
        </div>
        <div class="faq-item">
          <h3 class="faq-question">{{ 'dom_page.faq_4_question' | translate }}</h3>
          <p class="faq-answer">{{ 'dom_page.faq_4_answer' | translate }}</p>
        </div>
      </div>
    </section>

    <!-- Final CTA -->
    <section class="section-container" id="final-cta">
      <h2 class="section-title">{{ 'dom_page.cta_title' | translate }}</h2>
      <a [href]="environment.login_url">
        <app-button [title]="'dom_page.cta_button' | translate" [isOutline]="true"></app-button>
      </a>
      <p class="cta-subtext">{{ 'dom_page.cta_subtext' | translate }}</p>
    </section>
  </div>
</div>
